function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#ffcc00",
  d: "M49.64,50H14.36c-.75,0-1.36.68-1.36,1.5v3c0,.82.61,1.5,1.36,1.5h35.29c.75,0,1.36-.68,1.36-1.5v-3c0-.82-.61-1.5-1.36-1.5Z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#ffcc00",
  d: "M55.8,19.69c-2.32,0-4.2,1.96-4.2,4.38,0,.65.14,1.25.39,1.81l-6.34,3.96c-1.35.84-3.09.37-3.87-1.06l-7.13-13.03c.94-.8,1.55-2.01,1.55-3.38,0-2.42-1.88-4.38-4.2-4.38s-4.2,1.96-4.2,4.38c0,1.37.61,2.58,1.55,3.38l-7.13,13.03c-.78,1.43-2.53,1.9-3.87,1.06l-6.33-3.96c.24-.55.39-1.16.39-1.81,0-2.42-1.88-4.38-4.2-4.38s-4.21,1.96-4.21,4.38,1.88,4.38,4.2,4.38c.23,0,.46-.04.67-.07l6.33,17.61h33.6l6.33-17.61c.22.04.45.07.67.07,2.32,0,4.2-1.96,4.2-4.38s-1.88-4.38-4.2-4.38Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/Jackpot.0452fbdc.svg";
export { SvgComponent as ReactComponent };